/**
 * Compagnie VENDEUSE (`rate.vendor`) — sentinelle « inconnue ».
 *
 * `extractValidatingAirlineInfo` (serveur) ne trouve pas toujours de vendeuse : ni
 * `rate.vendor`, ni carrier au dictionnaire. Elle renvoie alors ce code plutôt que
 * `null`, pour que le champ reste une chaîne de bout en bout (cache, session, contrat).
 *
 * Conséquence : `??` ne protège de rien en aval — `'XX'` est non-nul et traverse tous
 * les replis nullish. Tout consommateur qui a un repli (opérante, carrier du journey
 * tarifé…) DOIT passer par {@link isKnownAirlineCode}, sans quoi il matche sur `'XX'` :
 * c'est ainsi qu'un code promo restreint à une compagnie se faisait silencieusement
 * rejeter sur les offres sans `rate.vendor`.
 */
export const UNKNOWN_AIRLINE_CODE = 'XX';
/** Vrai si le code est exploitable pour un matching (non vide et pas la sentinelle). */
export function isKnownAirlineCode(code) {
    return !!code && code !== UNKNOWN_AIRLINE_CODE;
}
/**
 * Compagnie retenue pour le matching d'un code promo : la vendeuse figée au shop, à
 * défaut le carrier du 1er journey tarifé.
 *
 * Le carrier du journey n'est qu'un repli : il vaut l'OPÉRANTE de son 1er tronçon, donc
 * `9B` (AccesRail) sur un TGV Air. On ne l'utilise que faute de vendeuse exploitable.
 */
export function resolveCompanyIataCode(storedCompanyIataCode, pricedCarrierCode) {
    if (isKnownAirlineCode(storedCompanyIataCode))
        return storedCompanyIataCode;
    return pricedCarrierCode ?? null;
}
